import api from './api';
import { apiPath } from '../config/apiConfig';

const notificationsAPI = {
  getNotifications: async (limit: number = 50, offset: number = 0) => {
    const response = await api.get(apiPath('/notifications'), { params: { limit, offset } });
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await api.get(apiPath('/notifications/unread-count'));
    return response.data;
  },

  markAsRead: async (notificationId: string) => {
    const response = await api.put(apiPath(`/notifications/${notificationId}/read`));
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await api.put(apiPath('/notifications/mark-all-read'));
    return response.data;
  },

  deleteNotification: async (notificationId: string) => {
    const response = await api.delete(apiPath(`/notifications/${notificationId}`));
    return response.data;
  },
};

export default notificationsAPI;
